import isFunction from 'lodash/isFunction';
import {
    PREVIEW_ELEMENT_TYPE,
    LOADING_ELEMENT_TYPE,
    DROPZONE_ELEMENT_TYPE,
} from './constants';

export const getFileFromDropEvent = (event) =>
    event.dataTransfer &&
    event.dataTransfer.files &&
    event.dataTransfer.files[0];

export const getFileFromBrowseEvent = (event) =>
    event.target && event.target.files && event.target.files[0];

export const isPromise = (promise = false) =>
    promise && isFunction(promise.then) && isFunction(promise.catch);

export const getActiveUploaderElementType = (showPreview, isLoading) => {
    if (showPreview) {
        return PREVIEW_ELEMENT_TYPE;
    }
    if (isLoading) {
        return LOADING_ELEMENT_TYPE;
    }
    return DROPZONE_ELEMENT_TYPE;
};

export const getActiveDropzoneElement = (
    isDraggedOver,
    windowDraggedOver,
    dropzoneElement,
    dragDropzoneElement,
    windowDragDropzoneElement,
) => {
    if (isDraggedOver) {
        return dragDropzoneElement;
    }
    if (windowDraggedOver) {
        return windowDragDropzoneElement || dragDropzoneElement;
    }
    return dropzoneElement;
};
